import { createFileRoute } from "@tanstack/react-router";
import { FirstRun } from "@/features/desktop/first-run";

// Desktop only: main opens its setup window here on the first launch. Browsers redirect home.
export const Route = createFileRoute("/first-run")({ component: FirstRun });
